import React from 'react';
import { FormattedMessage } from 'react-intl';
import isEmail from 'validator/lib/isEmail';
import Moment from 'moment-timezone';
import ArrayUtil from './ArrayUtil';

export const email = value => (typeof value === 'string' && isEmail(value) ? null : (
  <FormattedMessage id="errors.validation.invalidEmail" defaultMessage="Invalid email address" />
));

// eslint-disable-next-line max-len
export const required = value => (value ? undefined : <FormattedMessage id="errors.validation.required" defaultMessage="Required" />);

export const datetime = value => (!value || (value && Moment(value).isValid()) ? (
  undefined
) : (
  <FormattedMessage id="errors.date" defaultMessage="{description} must be a valid date" />
));

export const arrayDuplicated = (arrValue) => {
  if (ArrayUtil.isEmpty(arrValue)) {
    return null;
  }

  const setValue = Array.from(new Set(arrValue));
  if (ArrayUtil.isEmpty(setValue)) {
    return null;
  }

  return setValue.length < arrValue.length ? 'duplicated' : null;
};

export const matchConfirmationCode = (value, formValues) => {
  const dest = 'confirmation_code';
  const condition = !value || value === formValues[dest];
  return condition ? null : <FormattedMessage id="error.not_match" defaultMessage="No match." />;
};

export const matchConfirmPwd = (value, formValues) => {
  const dest = 're_pwd';
  const condition = !value || value === formValues[dest];
  return condition ? null : <FormattedMessage id="errors.not_match" defaultMessage="No match." />;
};
